import { Text } from '@components/primitives';
import React from 'react';
import { Pressable, View, StyleProp, ViewStyle } from 'react-native';
import styles from './style';

interface NormalDeptAlertProps {
  show: boolean;
  customContainer?: StyleProp<ViewStyle>;
  icon: React.ReactElement;
  title: string;
  iconRight: React.ReactElement;
  onPressHandler: () => void;
}

const NormalDeptAlert: React.FC<NormalDeptAlertProps> = ({
  show,
  customContainer = {},
  icon,
  title,
  iconRight,
  onPressHandler,
}) => {
  if (!show) return null;

  return (
    <Pressable onPress={onPressHandler} style={[styles.container, customContainer]} accessibilityRole="button">
      <View style={styles.styleAdj}>
        {icon}
        <Text variant="sm-bold" style={styles.textStyle}>
          {title}
        </Text>
      </View>
      {iconRight}
    </Pressable>
  );
};

export default NormalDeptAlert;
